<template>
  <VaSidebar
    v-model="writableVisible"
    :width="sidebarWidth"
    :color="color"
    minimized-width="0"
    class="pt-2 box-border bg-white"
  >
    <VaAccordion v-model="value" multiple>
      <VaCollapse v-for="(route, index) in navigationRoutes.routes" :key="index">
        <template #header="{ value: isCollapsed }">
          <VaSidebarItem
            :to="route.children ? undefined : { name: route.name }"
            :active="routeHasActiveChild(route)"
            :active-color="activeColor"
            :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${t(route.displayName)}`"
            role="button"
            hover-opacity="0.10"
            class="block w-[88%] mx-auto mt-1 rounded-[5px] border-0"
          >
            <VaSidebarItemContent class="py-0.5">
              <VaIcon v-if="route.meta.icon" aria-hidden="true" :name="route.meta.icon" size="20px" />
              <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold">
                {{ t(route.displayName) }}
                <VaIcon v-if="route.children" :name="arrowDirection(isCollapsed)" size="20px" />
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>
        <template #body>
          <div
            v-for="(childRoute, index2) in route.children"
            :key="index2"
            class="w-[88%] mx-auto rounded-[5px] border-0"
          >
            <VaSidebarItem
              :to="{ name: childRoute.name }"
              :active="isActiveChildRoute(childRoute)"
              :active-color="activeColor"
              :aria-label="`Visit ${t(route.displayName)}`"
              hover-opacity="0.10"
              class="w-[85%] ml-[15%] mt-1 rounded-[5px] border-0"
            >
              <VaSidebarItemContent class="py-0.5">
                <VaSidebarItemTitle class="leading-5 font-semibold">
                  {{ t(childRoute.displayName) }}
                </VaSidebarItemTitle>
              </VaSidebarItemContent>
            </VaSidebarItem>
          </div>
        </template>
      </VaCollapse>
    </VaAccordion>

    <!-- <div class="card text-center">
      <div class="card-body">
        <i class="feather-sunrise fs-4 text-dark"></i>
        <h6 class="mt-4 text-dark fw-bolder" style="font-size: 15px">{{ t('dashboard.siderBar.title') }}</h6>
        <p class="fs-11 my-3 text-dark">{{ t('dashboard.siderBar.info') }}</p>
        <RouterLink
          :to="{ name: 'support' }"
          class="btn btn-primary text-dark w-100"
          style="padding: 12px 16px; color: white !important; border-radius: 3px; font-weight: 700; font-size: 14px"
          >{{ t('dashboard.siderBar.btn') }}</RouterLink
        >
      </div>
    </div> -->
  </VaSidebar>
</template>
<script lang="ts">
import { defineComponent, watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router'

import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

import navigationRoutes, { type INavigationRoute } from './NavigationRoutes'

export default defineComponent({
  name: 'Sidebar',
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible'],

  setup: (props, { emit }) => {
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()
    const { t } = useI18n()

    const value = ref<boolean[]>([])

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const isActiveChildRoute = (child: INavigationRoute) =>
      route.name === child.name || (child.name == 'utm-components' && route.meta?.cate == 'utm-cpnt')

    const routeHasActiveChild = (section: INavigationRoute) => {
      if (!section.children) {
        return route.path.endsWith(`${section.name}`)
      }
      if (section.name == 'utm' && route.meta?.cate == 'utm-cpnt') {
        return true
      }
      return section.children.some(({ name }) => route.path.endsWith(`${name}`))
    }

    const setActiveExpand = () =>
      (value.value = navigationRoutes.routes.map((route: INavigationRoute) => routeHasActiveChild(route)))

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '279px'))
    const color = computed(() => getColor('background-secondary'))
    const activeColor = computed(() => colorToRgba(getColor('focus'), 1))

    const iconColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'secondary')
    const textColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'textPrimary')
    const arrowDirection = (state: boolean) => (state ? 'va-arrow-up' : 'va-arrow-down')

    watch(() => route.fullPath, setActiveExpand, { immediate: true })

    return {
      writableVisible,
      sidebarWidth,
      value,
      color,
      activeColor,
      navigationRoutes,
      routeHasActiveChild,
      isActiveChildRoute,
      t,
      iconColor,
      textColor,
      arrowDirection,
    }
  },
})
</script>

<style scoped>
.va-sidebar {
  border-right: 1px solid #e5e7eb;
}
.card {
  margin: 20px;
  color: #283c50;
  background: #eff0f6;
  border-color: #e5e7eb;
}
</style>
